import { AbstractSearchCriteria } from './abstract-search-criteria';

export class ProfileTypeSearchCriteria extends AbstractSearchCriteria
{
    code: string = '';
    name: string = '';
    codeOrName: string = '';
    resourceType: string = '';
}
